import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungFuerth() {
  return (
    <CityPageTemplate
      city="Fürth"
      slug="fuerth"
      intro="Fürth als Teil der Metropolregion Nürnberg – smarte Finanzberatung für die Kleeblattstadt."
      description="Unabhängige & digitale Finanzberatung für Fürth: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
